import dayjs from 'dayjs';
import { PresetKeyEnum } from 'infrastructure/enums';

import type { ITimeframePreset } from './types';

export const MIN_RANGE_DAYS = 7;
export const MAX_RANGE_MONTHS = 3;

const createTimeRange = (
  value: number,
  unit: 'hour' | 'day',
): [ReturnType<typeof dayjs>, ReturnType<typeof dayjs>] => {
  return [dayjs().add(-value, unit), dayjs()];
};

const createMonthRange = (
  monthsToSubtract: number,
): [ReturnType<typeof dayjs>, ReturnType<typeof dayjs>] => {
  const targetMonth = dayjs().add(-monthsToSubtract, 'month');
  return [targetMonth.startOf('month'), targetMonth.endOf('month')];
};

export const createRangePresets = (): ITimeframePreset[] => [
  {
    label: 'Last 7 days',
    value: createTimeRange(7, 'day'),
    key: PresetKeyEnum.LastSevenDays,
  },
  {
    label: 'Last 14 days',
    value: createTimeRange(14, 'day'),
    key: PresetKeyEnum.LastFourteenDays,
  },
  {
    label: 'Current Month',
    value: [dayjs().startOf('month'), dayjs()],
    key: PresetKeyEnum.CurrentMonth,
  },
  {
    label: 'Previous Month',
    value: createMonthRange(1),
    key: PresetKeyEnum.PreviousMonth,
  },
  {
    label: 'Two Months Past',
    value: createMonthRange(2),
    key: PresetKeyEnum.TwoMonthsPast,
  },
  {
    label: 'Three Months Past',
    value: createMonthRange(3),
    key: PresetKeyEnum.ThreeMonthsPast,
  },
];

const RANGE_PRESETS = createRangePresets();

export const getPresetByKey = (
  key: string,
): [ReturnType<typeof dayjs>, ReturnType<typeof dayjs>] | null => {
  const preset = RANGE_PRESETS.find((p) => p.key === key);
  return preset ? preset.value : null;
};
